import {Component, EventEmitter, ViewChildren} from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';

@Component({
    selector: 'dk-form-inline-row',
    template: require('./form-inline-row.html'),
    inputs: ['model', 'modelName', 'modelType', 'labelText', 'valMessage', 'valRequired', 'modelGroup', 'focus',
        'items', 'selectIdField', 'selectNameField', 'readonly', 'selectEmptyOption', 'numberSuffix', 'inputWrapperClass']
})

export class FormInlineRowComponent {
    @ViewChildren('input') vc;
    modelGroup: FormGroup;
    labelText: string;
    valMessage: string | any = "Common.RequiredField";
    valRequired: boolean = null;
    focus: boolean = false;
    readonly: boolean = false;
    modelName: string;
    modelType: string = 'text';
    model: any;
    items: any[];
    id: string;
    selectNameField: string = 'Name';
    selectIdField: string = 'Id';
    numberSuffix: string;
    selectEmptyOption: string;
    inputWrapperClass: string;

    get showValidationError(): boolean {
        if (this.formControl != null) {
            let result = !this.formControl.valid && this.formControl.touched;
            return result;
        }

        return false;
    }

    get formControl(): FormControl {
        if (this.modelGroup == null) {
            return null;
        }

        return this.modelGroup.controls[this.modelName] as FormControl;
    }

    constructor() {
        this.id = Math.random().toString(36).substring(7);
    }

    isNumber() {
        return this.modelType === 'number';
    }

    isCheckbox() {
        return this.modelType === 'checkbox';
    }

    isSelect() {
        return this.modelType === 'select';
    }

    isRadio() {
        return this.modelType === 'radio';
    }

    isTextarea() {
        return this.modelType === 'textarea';
    }

    isPhone() {
        return this.modelType === 'phone';
    }

    isDate() {
        return this.modelType === 'date';
    }

    isCustom() {
        return this.modelType === 'custom';
    }

    public ngAfterViewInit() {
        if (this.focus) {
            this.vc.first.nativeElement.focus();
        }
    }

    getId(index) {
        return this.id + index;
    }

    get calculatedValidationMessage(): string {
        if (typeof(this.valMessage) === 'string') {
            return this.valMessage;
        }

        let errors = (this.formControl as any)._errors;

        for(let key in errors) {
            if (key in this.valMessage) {
                return this.valMessage[key];
            }
        }

        return 'Common.RequiredField';
    }
}
